import { SpatialLevels } from "@station/domain/models/spatial-level.model.ts";
import type { SpatialLevelRepository } from "@station/domain/repositories/spatial-level.repository.ts";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class SpatialLevelGetLocalUseCase {
    constructor(
        @inject(stationsTypes.repositories.SpatialLevelRepository)
        private readonly spatialLevelRepository: SpatialLevelRepository,
    ) {}

    execute(): SpatialLevels {
        return this.spatialLevelRepository.spatialLevelsGetLocal();
    }
}
